import {useEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {HeaderWrapper} from './components/header';
import {ScrollTop} from './components/scroll-top';
import {Content} from './components/content';
import {FooterWrapper} from './components/footer';
import {Sidebar} from './components/sidebar';
import {ThemeModeProvider} from '../partials';
import {PageDataProvider} from './core';
import {reInitMenu} from '../helpers';
// import {ToolbarWrapper} from './components/toolbar';
// import Breadcrumbs from './components/header/Breadcrumbs';

const MasterLayout = () => {
    const location = useLocation();
    useEffect(() => {
        reInitMenu();
    }, [location.key]);

    return (
        <PageDataProvider>
            <ThemeModeProvider>
                <a href="#main-content" className="visually-hidden-focusable">
                    Aller au contenu principal
                </a>
                <div className="d-flex flex-column flex-root app-root" id="kt_app_root">
                    <div className="app-page flex-column flex-column-fluid" id="kt_app_page">
                        <header>
                            <HeaderWrapper />
                        </header>
                        <div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
                            <nav aria-label="Navigation principale">
                                <Sidebar />
                            </nav>
                            <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
                                <div className="d-flex flex-column flex-column-fluid">
                                    <div className={'app-container pt-4'}>
                                        {/* <Breadcrumbs /> */}
                                        {/* <ToolbarWrapper /> */}
                                    </div>
                                    <main id="main-content">
                                        <Content>
                                            <Outlet />
                                        </Content>
                                    </main>
                                </div>
                                <footer>
                                    <FooterWrapper />
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollTop />
            </ThemeModeProvider>
        </PageDataProvider>
    );
};

export {MasterLayout};
